import useFetch from 'use-http'
import { createGetUrl } from '../../utils'

export const useListClasses = ({ courseId }) => {
  const response = useFetch(createGetUrl('ListaAulas', courseId), null, [courseId])

  return response
}
